import { useState, useEffect, useCallback, useMemo } from "react";

const useLanguageDirection = () => {
  const [direction, setDirection] = useState(() => {
    // Initialize only once
    return localStorage.getItem("language") === "ar" ? "rtl" : "ltr";
  });

  const updateDirection = useCallback(() => {
    const language = localStorage.getItem("language");
    setDirection(language === "ar" ? "rtl" : "ltr");
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      updateDirection();
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [updateDirection]);

  // Memoize the direction value
  const memoizedDirection = useMemo(() => direction, [direction]);

  return memoizedDirection;
};

export default useLanguageDirection;
